/* eslint-disable react-refresh/only-export-components -- module exports router + route helpers */
import { lazy, Suspense, type ReactNode } from 'react'
import { createBrowserRouter, type RouteObject } from 'react-router-dom'
import { AppShell } from '@/app/layout/app-shell'
import { AppPaths } from '@/config/app-paths'
import { AuthLoadingScreen, RequireAuth } from '@/features/auth/components/require-auth'
import { protectedRouteChildren } from '@/app/routes/protected-routes'
import { RouteErrorFallback } from '@/shared/components/route-error-fallback'

const LoginPage = lazy(async () => ({
  default: (await import('@/features/auth/pages/login-page')).LoginPage,
}))

const AcceptInvitePage = lazy(async () => ({
  default: (await import('@/features/auth/pages/accept-invite-page')).AcceptInvitePage,
}))

const StockDecisionPage = lazy(async () => ({
  default: (await import('@/features/stocks/pages/stock-decision-page')).StockDecisionPage,
}))

function LazyBoundary({ children }: { children: ReactNode }) {
  return (
    <Suspense
      fallback={
        <div className="flex min-h-[40vh] items-center justify-center text-sm text-text-secondary">
          Loading…
        </div>
      }
    >
      {children}
    </Suspense>
  )
}

const routes: RouteObject[] = [
  {
    path: AppPaths.login,
    element: (
      <LazyBoundary>
        <LoginPage />
      </LazyBoundary>
    ),
    HydrateFallback: AuthLoadingScreen,
  },
  {
    path: AppPaths.acceptInvite,
    element: (
      <LazyBoundary>
        <AcceptInvitePage />
      </LazyBoundary>
    ),
    HydrateFallback: AuthLoadingScreen,
  },
  {
    path: '/stock-decision',
    element: (
      <LazyBoundary>
        <StockDecisionPage />
      </LazyBoundary>
    ),
  },
  {
    path: '/',
    element: <RequireAuth />,
    errorElement: <RouteErrorFallback />,
    HydrateFallback: AuthLoadingScreen,
    children: [
      {
        element: <AppShell />,
        errorElement: <RouteErrorFallback />,
        HydrateFallback: AuthLoadingScreen,
        children: protectedRouteChildren,
      },
    ],
  },
]

export const router = createBrowserRouter(routes)
